import React, { ReactNode } from 'react';
import classNames from 'classnames';
import WarningExclamationIcon from 'icons/WarningExclamation.icon';

import './WarningBanner.styles.scss';

type WarningBannerProps = {
  className?: string;
  icon?: ReactNode;
  title: string;
  description?: string;
};

const WarningBanner: React.FC<WarningBannerProps> = (props) => {
  const {
    className,
    title,
    description,
    icon = <WarningExclamationIcon />,
  } = props;

  const classes = classNames('warning-banner', className);

  return (
    <div className={classes}>
      <div>
        {icon}
        <p>{title}</p>
      </div>

      {description && <p>{description}</p>}
    </div>
  );
};

export default WarningBanner;
